interface SignInDialog {
  visible: boolean;
  afterLogin: string | null;
}

const signInDialog = {
  namespaced: true,
  state: {
    visible: false,
    afterLogin: null
  } as SignInDialog,
  mutations: {
    setVisible(state: SignInDialog, visible: boolean) {
      state.visible = visible;
    },
    setAfterLogin(state: SignInDialog, next: string) {
      state.afterLogin = next;
    }
  }
};

export default signInDialog;
